import { getAppCfg } from "../core/app-cfg";
import { EDITOR_VIEW_NAME, RESULT_CODE } from "../core/constants";
import { getComponentData, getViewData, setComponentData } from "../core/views";
import { getCloudUser, serverFeatureAvailable } from "./cloudstorage/cloud";

export const initResultCode = () : void => {
  const resultCodeData = {
    startTime : Date.now(),
    currentPoints : 0
  }
  setComponentData(RESULT_CODE, resultCodeData)
}

const generateUserKey = () : string => {

  if (serverFeatureAvailable() && getCloudUser().loggedIn) {
    return getCloudUser().userName;
  }

  const randomId = Math.floor(Math.random() * 1200) + 1000;
  const userId = randomId;
  return `${userId}`;
}

//TODO Uint8Array and toString(16)
const digestMessage = async (message : string) : Promise<string> => {
  const msgUint8 = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
}

export const addPoints = (points : number) => {
  const resultCodeData = getComponentData(RESULT_CODE);
  resultCodeData.currentPoints += points;
  setComponentData(RESULT_CODE, resultCodeData);
}

export const getMaxPoints = () => {
  return getComponentData(RESULT_CODE).maxPoints;
}

export const generateResultCode = () : void => {

  const resultCodeData = getComponentData(RESULT_CODE);
  const userKey = generateUserKey();
  const maxPoints = getViewData(EDITOR_VIEW_NAME).project?.maxPoints || resultCodeData.maxPoints;
  const currentPoints = resultCodeData.currentPoints;
  const projectId = getAppCfg().projectId;
  const currentElapsedSeconds = resultCodeData.startTime ? Math.floor((Date.now() - resultCodeData.startTime)/1000) : -1;

  const resultCodeList : string[] = [];
  resultCodeList.push(userKey);
  resultCodeList.push(maxPoints);
  resultCodeList.push(currentPoints);
  resultCodeList.push(projectId);
  resultCodeList.push(currentElapsedSeconds.toString());
  const data = resultCodeList.join(";");
  //console.log("resultCode List,", data)

  const salt = ";salt";
  digestMessage(data + salt).then(hash => {
    resultCodeList.push(hash.substring(0,5));
    const resultCode = resultCodeList.join(";")
    resultCodeData.data = resultCode;
    //console.log("resultCode Data,", resultCodeData.data)
    resultCodeData.code = btoa(resultCode);
    setComponentData(RESULT_CODE, resultCodeData);
  });
}



